/* @flow */

const badgeStatus = (status: string) => {
    switch (status.toUpperCase()) {
    case 'INITIATED':
        return '<span class="m-badge m-badge--wide m-badge--info">INICIADA</span>';

    case 'PENDING':
        return '<span class="m-badge m-badge--wide m-badge--warning">PENDENTE</span>';

    case 'ACTIVE':
        return '<span class="m-badge m-badge--wide m-badge--success">PAGO</span>';

    case 'PAID':
        return '<span class="m-badge m-badge--wide m-badge--success">PAGO</span>';

    case 'PAYMENT_METHOD_CHANGE':
        return '<span class="m-badge m-badge--wide m-badge--brand">MUDANÇA DE FORMA DE PAGAMENTO</span>';

    case 'SUSPENDED':
        return '<span class="m-badge m-badge--wide m-badge--primary">SUSPENSA</span>';

    case 'CANCELLED':
        return '<span class="m-badge m-badge--wide m-badge--danger">CANCELADA</span>';

    case 'CANCELLED_BY_RECEIVER':
        return '<span class="m-badge m-badge--wide m-badge--danger">CANCELADO PELO VENDEDOR</span>';

    case 'CANCELLED_BY_SENDER':
        return '<span class="m-badge m-badge--wide m-badge--danger">CANCELADO PELO CLIENTE</span>';

    case 'EXPIRED':
        return '<span class="m-badge m-badge--wide m-badge--metal">EXPIRADA</span>';

    case 'DRAFT':
        return '<span class="m-badge m-badge--wide m-badge--metal">RASCUNHO</span>';

    case ' PARTIALLY_PAID':
        return '<span class="m-badge m-badge--wide m-badge--info">PARCIALMENTE PAGA</span>';

    case 'REFUNDED':
        return '<span class="m-badge m-badge--wide m-badge--warning">REEMBOLSADA</span>';

    case 'IN_PROTEST':
        return '<span class="m-badge m-badge--wide m-badge--primary">EM PROTESTO</span>';

    case 'CHARGEBACK':
        return '<span class="m-badge m-badge--wide m-badge--danger">CHARGEBACK</span>';

    case 'IN_ANALYSIS':
        return '<span class="m-badge m-badge--wide m-badge--primary">EM ANÁLISE</span>';

    case 'AGUARDANDO PAGAMENTO':
        return '<span class="m-badge m-badge--wide m-badge--info">AGUARDANDO PAGAMENTO</span>';

    case 'EM ANÁLISE':
        return '<span class="m-badge m-badge--wide m-badge--primary">EM ANÁLISE</span>';

    case 'PAGA':
        return '<span class="m-badge m-badge--wide m-badge--success">PAGA</span>';

    case 'DISPONÍVEL':
        return '<span class="m-badge m-badge--wide m-badge--primary">DISPONÍVEL</span>';

    case 'EM DISPUTA':
        return '<span class="m-badge m-badge--wide m-badge--metal">EM DISPUTA</span>';

    case 'DEVOLVIDA':
        return '<span class="m-badge m-badge--wide m-badge--danger">DEVOLVIDA</span>';

    case 'CANCELADA':
        return '<span class="m-badge m-badge--wide m-badge--danger">CANCELADA</span>';

    case 'DEBITADO':
        return '<span class="m-badge m-badge--wide m-badge--warning">DEBITADO</span>';

    case 'RETENÇÂO TEMPORÁRIA':
        return '<span class="m-badge m-badge--wide m-badge--info">RETENÇÂO TEMPORÁRIA</span>';

    default:
        return '<span class="m-badge m-badge--wide m-badge--info">STATUS DESCONHECIDO</span>';
    }
};

export default badgeStatus;
